import type {ReactElement} from 'react';
import React from 'react';
import {BaseBlackAndWhiteOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-black-and-white-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';

export function SlideshowItemBlackAndWhiteOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const blackAndWhite = useGetKeyFromEffectsOfActiveSlideItem('blackAndWhite');

  if (!activeItem || !activeSlideUID) {
    throw new Error('Active item or active slide is not defined in slideshow item effects options');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, got ${activeItem.gitype} instead`);
  }

  if (blackAndWhite === undefined) {
    throw new Error('blackandwhite is undefined for active slide item');
  }

  const onToggleHandler = (): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      effects: {
        blackAndWhite: !blackAndWhite,
      },
    });
  };

  return <BaseBlackAndWhiteOption isChecked={blackAndWhite} onToggleOption={onToggleHandler} />;
}
